import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Navbar from './components/Layout/Navbar';
import Dashboard from './components/Dashboard/Dashboard';
import UserManagement from './components/Users/UserManagement';
import TransactionList from './components/Transactions/TransactionList';
import Settlements from './components/Settlements/Settlements';
import Reconciliation from './components/Reconciliation/Reconciliation';
import Settings from './components/Settings/Settings';
import CreatePaymentLinkPage from './components/PaymentLinks/CreatePaymentLinkPage';
import IssueInvoicePage from './components/PaymentLinks/IssueInvoicePage';
import EmbedPage from './components/Embed/EmbedPage';
import EmbedTest from './components/Embed/EmbedTest';
import IframePaymentPage from './components/Iframe/IframePaymentPage';
import { getCurrentUserRole } from './utils/auth';
import { setupAxiosInterceptors } from './utils/axiosInterceptor';

function App() {
  const userRole = getCurrentUserRole();
  
  useEffect(() => {
    // Setup axios interceptors for automatic token refresh
    setupAxiosInterceptors();
  }, []);
  
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<ProtectedRoute><><Navbar /><Dashboard /></></ProtectedRoute>} />
        <Route 
          path="/users" 
          element={
            userRole === 'Agent' ? 
              <Navigate to="/dashboard" /> : 
              <ProtectedRoute><><Navbar /><UserManagement /></></ProtectedRoute>
          } 
        />
        <Route path="/transactions" element={<ProtectedRoute><><Navbar /><TransactionList /></></ProtectedRoute>} />
        <Route path="/settlements" element={<ProtectedRoute><><Navbar /><Settlements /></></ProtectedRoute>} />
        <Route path="/reconciliation" element={<ProtectedRoute><><Navbar /><Reconciliation /></></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><><Navbar /><Settings /></></ProtectedRoute>} />
        <Route path="/payments/new" element={<ProtectedRoute><><Navbar /><CreatePaymentLinkPage /></></ProtectedRoute>} />
        <Route path="/payments/invoice" element={<ProtectedRoute><><Navbar /><IssueInvoicePage /></></ProtectedRoute>} />
        <Route path="/embed-test" element={<ProtectedRoute><><Navbar /><EmbedTest /></></ProtectedRoute>} />
        <Route path="/iframe/:apiKey" element={<IframePaymentPage />} />
        <Route path="/pay/:uniqueHash" element={<EmbedPage />} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;